<div *ngIf="isMobileTabletLandscape(); else appContent" class="landscape-block">
    <div class="landscape-card">
        <div class="rotate-icon">📱</div>

        <h2>Rotate Your Device</h2>

        <p>
            This page works best in portrait mode.<br />
            Please rotate your device to continue.
        </p>
    </div>
</div>

<!-- Preload critical icons for better performance -->
<img src="assets/svg/icons/eye-gs.svg" alt="" style="display: none" srcset="" />
<img src="assets/svg/icons/retry.svg" alt="" style="display: none" srcset="" />
<img src="assets/svg/icons/glow.svg" alt="" style="display: none" srcset="" />
<img src="assets/svg/icons/no-internet-gbs.svg" alt="" style="display: none" srcset="" />

<ng-template #appContent>
    <app-splash-screen *ngIf="isSplashScreen"></app-splash-screen>
    <div class="master-layout" *ngIf="!isSplashScreen">
        <main class="master-layout-container">
            <aside
                class="sidebar"
                [class.hideSidebar]="!(globalService.showSidebar | async)"
                [class.is-open]="globalService.sidebarToggle | async"
            >
                <web-sidebar></web-sidebar>
            </aside>

            <div
                class="sidebar-overlay"
                *ngIf="globalService.sidebarToggle | async"
                (click)="toggleSidebarForHide()"
            ></div>

            <div class="main">
                <header class="header" [class.hideHeader]="!(globalService.showHeader | async)">
                    <web-header></web-header>
                </header>

                <section class="content">
                    <app-loader *ngIf="loaderService.loader | async"></app-loader>
                    <router-outlet></router-outlet>
                </section>
            </div>
        </main>
    </div>

    <!-- <div class="app-master-layout">
        <router-outlet></router-outlet>
    </div> -->

    <!-- Bottom Install Banner -->
    <!-- <div *ngIf="pwa.showInstallButton" class="install-banner">
        <span class="text">📲 Install Klinq Loan App for quicker access</span>
        <div class="actions">
            <button class="install" (click)="pwa.promptInstall()">Install</button>
            <button class="cancel" (click)="pwa.skipInstall()">Not Now</button>
        </div>
    </div> -->
</ng-template>
